export default "/images/framework/Epic.e3de0e2f.svg?e3de0e2f";